/* eslint-disable */
import React from "react";
import ShortModal from "../../../../Universal/ShortModal.component";
import NormalToggleInputField from "../../../../Universal/NormalToggleInputField.component";
import PropTypes from "prop-types";
const EventDetailsModal = ({
  onClose,
  modalStatus,
  data,
  handelComplete,
  handelDelete,
}) => {
  return (
    <ShortModal
      title={"Create Meeting"}
      onClose={() => onClose()}
      isOpen={modalStatus}
    >
      <div className="flex-col g-3" style={{ width: "20rem" }}>
        <h3 className="w-full t-20 text-align-center weight-500 poppins color-gray">
          Event details
        </h3>

        <div className="flex-1 flex-col align-start justify-start g-2">
          <NormalToggleInputField
            label="Online"
            type={"checkbox"}
            name={"eventDetailsToggleBtn"}
            value={data && data[0].eventMode}
            setFieldValue={() => setToggleBtn()}
            isRequired={false}
            checked={
              data && data[0].eventMode.toString().toLowerCase() === "online"
                ? true
                : false
            }
          />
          <div className="flex-col align-start justify-start g-1">
            <div className="flex-row align-center justify-start g-05 color-gray">
              <label htmlFor="" className="t-14 poppins">
                Event Name :
              </label>
              <span
                className="t-14 poppins"
                style={{ color: "var(--textColor)" }}
              >
                &nbsp;{data && data[0].eventName}
              </span>
            </div>

            <div className="flex-row align-center justify-start g-05 color-gray">
              <label htmlFor="" className="t-14 poppins">
                Subject :
              </label>
              <span
                className="t-14 poppins"
                style={{ color: "var(--textColor)" }}
              >
                &nbsp;{data && data[0].subject}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05 color-gray">
              <label htmlFor="" className="t-14 poppins">
                Time :
              </label>
              <span
                className="t-14 poppins"
                style={{ color: "var(--textColor)" }}
              >
                &nbsp;{data && data[0].time}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05 color-gray">
              <label htmlFor="" className="t-14 poppins">
                Starting Date :
              </label>
              <span
                className="t-14 poppins"
                style={{ color: "var(--textColor)" }}
              >
                &nbsp;{data && data[0].eventDate.toString().split("-")[0]}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05 color-gray">
              <label htmlFor="" className="t-14 poppins">
                Ending Date :
              </label>
              <span
                className="t-14 poppins"
                style={{ color: "var(--textColor)" }}
              >
                &nbsp;{data && data[0].eventDate.toString().split("-")[1]}
              </span>
            </div>
          </div>
          <div className="flex-col align-start justify-start g-1 w-full">
            <button
              className="actionBtn w-full poppins"
              onClick={() => handelComplete(data && data[0]._id)}
            >
              Mark as complete
            </button>
            <button
              className="deleteBtn w-full poppins"
              onClick={() => handelDelete(data && data[0]._id)}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </ShortModal>
  );
};

export default EventDetailsModal;
EventDetailsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  modalStatus: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  handelComplete: PropTypes.func.isRequired,
  handelDelete: PropTypes.func.isRequired,
};
